/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BranchType } from '../models/BranchType';
import type { CIFModel } from '../models/CIFModel';
import type { DigitalWipCommonDetailsModel } from '../models/DigitalWipCommonDetailsModel';
import type { DigitalWipListItemModelPagedListData } from '../models/DigitalWipListItemModelPagedListData';
import type { DigitalWipPhotoModel } from '../models/DigitalWipPhotoModel';
import type { DigitalWipTabTypeFilterEnum } from '../models/DigitalWipTabTypeFilterEnum';
import type { NoteModel } from '../models/NoteModel';
import type { QualityCheckFinishSubmitModel } from '../models/QualityCheckFinishSubmitModel';
import type { QualityCheckStartSubmitModel } from '../models/QualityCheckStartSubmitModel';
import type { QualityCheckTestDriveModel } from '../models/QualityCheckTestDriveModel';
import type { TechnicianJobDetailModel } from '../models/TechnicianJobDetailModel';
import type { WIPDetailedLaboursAndPartsModel } from '../models/WIPDetailedLaboursAndPartsModel';
import type { WipServicePdfModel } from '../models/WipServicePdfModel';
import type { WLClockTechnicianUserModel } from '../models/WLClockTechnicianUserModel';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class DigitalWipService {

  /**
   * @param tabType
 *
 * 0 = CheckedIn
 *
 * 1 = CheckedOut
 *
 * 2 = Closed
   * @param dueInFrom 
   * @param dueInTo 
   * @param branch
 *
 * 1 = Slough
 *
 * 2 = HighWycombe
 *
 * 3 = Maidenhead
 *
 * 4 = Watford
 *
 * 6 = HemelHempstead
 *
 * 7 = Romford
   * @param technician 
   * @param technicianUserId 
   * @param bookingType 
   * @param regNo 
   * @param wipNo 
   * @param wipStatus 
   * @param page 
   * @param pageSize 
   * @returns DigitalWipListItemModelPagedListData Success
   * @throws ApiError
   */
  public static getDigitalWip(
tabType?: DigitalWipTabTypeFilterEnum,
dueInFrom?: string,
dueInTo?: string,
branch?: BranchType,
technician?: string,
technicianUserId?: number,
bookingType?: number,
regNo?: string,
wipNo?: number,
wipStatus?: number,
page?: number,
pageSize?: number,
): CancelablePromise<DigitalWipListItemModelPagedListData> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip',
      query: {
        'TabType': tabType,
        'DueInFrom': dueInFrom,
        'DueInTo': dueInTo,
        'Branch': branch,
        'Technician': technician,
        'TechnicianUserId': technicianUserId,
        'BookingType': bookingType,
        'RegNo': regNo,
        'WipNo': wipNo,
        'WipStatus': wipStatus,
        'Page': page,
        'PageSize': pageSize,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns DigitalWipCommonDetailsModel Success
   * @throws ApiError
   */
  public static getDigitalWip1(
id: number,
): CancelablePromise<DigitalWipCommonDetailsModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns WIPDetailedLaboursAndPartsModel Success
   * @throws ApiError
   */
  public static getDigitalWipWipLaboursAndPartsDetails(
id: number,
): CancelablePromise<Array<WIPDetailedLaboursAndPartsModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}/wip-labours-and-parts-details',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns TechnicianJobDetailModel Success
   * @throws ApiError
   */
  public static getDigitalWipTechnicianJobDetails(
id: number,
): CancelablePromise<TechnicianJobDetailModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}/technician-job-details',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns DigitalWipPhotoModel Success
   * @throws ApiError
   */
  public static getDigitalWipWarrantyRepairPhotos(
id: number,
): CancelablePromise<Array<DigitalWipPhotoModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}/warranty-repair-photos',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns CIFModel Success
   * @throws ApiError
   */
  public static getDigitalWipCif(
id: number,
): CancelablePromise<Array<CIFModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}/cif',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param regno 
   * @returns WipServicePdfModel Success
   * @throws ApiError
   */
  public static getDigitalWipPdf(
regno?: string,
): CancelablePromise<Array<WipServicePdfModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/pdf',
      query: {
        'regno': regno,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns NoteModel Success
   * @throws ApiError
   */
  public static getDigitalWipNotes(
id: number,
): CancelablePromise<Array<NoteModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}/notes',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns QualityCheckTestDriveModel Success
   * @throws ApiError
   */
  public static getDigitalWipQualityCheckTestDrive(
id: number,
): CancelablePromise<Array<QualityCheckTestDriveModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/{id}/quality-check-test-drive',
      path: {
        'id': id,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postDigitalWipQualityCheckTestDriveStart(
id: number,
requestBody?: QualityCheckStartSubmitModel,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/digital-wip/{id}/quality-check-test-drive-start',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDigitalWipQualityCheckTestDriveFinish(
id: number,
requestBody?: QualityCheckFinishSubmitModel,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/digital-wip/{id}/quality-check-test-drive-finish',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param branchId 
   * @returns WLClockTechnicianUserModel Success
   * @throws ApiError
   */
  public static getDigitalWipWlclockTechUsers(
branchId?: number,
): CancelablePromise<Array<WLClockTechnicianUserModel>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/digital-wip/wlclock-tech-users',
      query: {
        'branchId': branchId,
      },
      errors: {
        400: `Bad Request`,
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @param techRepairId 
   * @param userId 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postDigitalWipCreateRepairQuotesFromPartRequest(
id: number,
techRepairId?: number,
userId?: number,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/digital-wip/{id}/create-repair-quotes-from-part-request',
      path: {
        'id': id,
      },
      query: {
        'techRepairId': techRepairId,
        'userId': userId,
      },
      errors: {
        404: `Not Found`,
      },
    });
  }

  /**
   * @param id 
   * @returns any Success
   * @throws ApiError
   */
  public static postDigitalWipSendSmsQuotes(
id: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/digital-wip/{id}/send-sms-quotes',
      path: {
        'id': id,
      },
    });
  }

}
